export default __webpack_public_path__ + "static/IN-Motion300_00-fdf50e8caafc160efec659550d0edaf2.webp";